/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class SettingKeys {
    static readonly is_fake_ai_agent_enabled: string = "IsFakeAiAgentEnabled";
}
